module.exports = __webpack_public_path__ + "static/media/NZ.62c69ddc.png";